/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import i18nAdhoc from '../../../../i18n/AdHocBundle.properties';

export default {
    'Crosstab': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.column.or.row']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.column.or.row']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconCrosstab '
    },
    'Table': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.groups']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTable'
    },
    'Column': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconColumn'
    },
    'StackedColumn': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconStackedColumn'
    },
    'StackedPercentColumn': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconPercentColumn'
    },
    'Bar': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconBar'
    },
    'StackedBar': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconStackedBar'
    },
    'StackedPercentBar': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconPercentBar'
    },
    'SpiderColumn': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconSpiderColumn'
    },
    'Line': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconLine'
    },
    'Spline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconSpline'
    },
    'Area': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconArea'
    },
    'StackedArea': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconStackedArea'
    },
    'StackedPercentArea': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconPercentArea'
    },
    'AreaSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.date.time'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconAreaSpline'
    },
    'SpiderLine': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconSpiderLine'
    },
    'SpiderArea': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconSpiderArea'
    },
    'ColumnLine': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconColumnLine'
    },
    'ColumnSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconColumnSpline'
    },
    'StackedColumnLine': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.three.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconStackedColumnLine'
    },
    'StackedColumnSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.three.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconStackedColumnSpline'
    },
    'MultiAxisLine': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconMultiAxisLine'
    },
    'MultiAxisSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconMultiAxisSpline'
    },
    'MultiAxisColumn': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconMultiAxisColumn'
    },
    'TimeSeriesLine': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.time.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.time.description']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTimeSeriesLine'
    },
    'TimeSeriesSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.time.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.time.description']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTimeSeriesSpline'
    },
    'TimeSeriesArea': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.time.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.time.description']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTimeSeriesArea'
    },
    'TimeSeriesAreaSpline': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.time.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.time.description']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTimeSeriesAreaSpline'
    },
    'Scatter': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.column.andor.row']
            },
            {
                first: i18nAdhoc['adhoc.rule.two'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconScatter'
    },
    'Bubble': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.column.andor.row']
            },
            {
                first: i18nAdhoc['adhoc.rule.three'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconBubble'
    },
    'Pie': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconPie'
    },
    'DualLevelPie': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.two'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconDualLevelPie'
    },
    'SemiPie': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                }
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                }
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconSemiPie'
    },
    'HeatMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.followed.one'],
                'fourth': {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                'fifth': i18nAdhoc['adhoc.rule.in.column'],
                'type': 'twospan'
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconHeatMap'
    },
    'TimeSeriesHeatMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.time.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.time.hours']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTimeSeriesHeatMap'
    },
    'DualMeasureTreeMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.two'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconDualMeasureTreeMap'
    },
    'TreeMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTreeMap'
    },
    'OneParentTreeMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconParentTreeMap'
    },
    'TileMap': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.followed.one'],
                'fourth': {
                    msg: i18nAdhoc['adhoc.rule.measure'],
                    type: 'measure'
                },
                'fifth': i18nAdhoc['adhoc.rule.in.column'],
                'type': 'twospan'
            },
            {
                first: i18nAdhoc['adhoc.rule.one'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.field'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.rows']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconTileMap'
    },
    'Gauge': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.or'],
                'fourth': {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                'fifth': i18nAdhoc['adhoc.rule.in.rows'],
                'type': 'twospan'
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconGauge'
    },
    'MultiLevelGauge': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.or'],
                'fourth': {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                'fifth': i18nAdhoc['adhoc.rule.in.rows'],
                'type': 'twospan'
            },
            {
                first: i18nAdhoc['adhoc.rule.two.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconMultiLevelGauge'
    },
    'ArcGauge': {
        rules: [
            {
                first: i18nAdhoc['adhoc.rule.zero.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            },
            {
                first: i18nAdhoc['adhoc.rule.zero'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.fields'],
                    type: 'field'
                },
                third: i18nAdhoc['adhoc.rule.or'],
                'fourth': {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                'fifth': i18nAdhoc['adhoc.rule.in.rows'],
                'type': 'twospan'
            },
            {
                first: i18nAdhoc['adhoc.rule.one.more'],
                second: {
                    msg: i18nAdhoc['adhoc.rule.measures'],
                    type: 'measure'
                },
                third: i18nAdhoc['adhoc.rule.in.column']
            }
        ],
        iconClassName: 'jr-mVisualchooser-rule-iconArcGauge'
    }
};
